var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "aria-label": "Amazon Simple Storage Service",
        role: "img",
        viewBox: "0 0 512 512",
      },
    },
    [
      _c("rect", {
        attrs: { width: "512", height: "512", rx: "15%", fill: "#ffffff" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { fill: "#e05243", d: "M260 348l-137 33V131l137 32z" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { fill: "#8c3123", d: "M256 349l133 32V131l-133 32v186" },
      }),
      _vm._v(" "),
      _c("g", { attrs: { fill: "#e05243" } }, [
        _c("path", {
          attrs: {
            id: "a",
            d: "M256 64v97l58 14V93zm133 67v250l26-13V143zm-133 77v97l58-8v-82zm58 129l-58 14v97l58-29z",
          },
        }),
      ]),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: "#8c3123",
          transform: "rotate(180 256 256)",
          "xlink:href": "#a",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { fill: "#5e1f18", d: "M314 175l-58 11-58-11 58-15 58 15" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { fill: "#f2b0a9", d: "M314 337l-58-11-58 11 58 16 58-16" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }